import { IColorMap } from '../types';

export const lightThemeColors: IColorMap = {
  hiContrast: '#262626',
  loContrast: 'white',
  diffContrastColor: '#FFFFFF',
  diffContrastBgColor: '#000000',
  accentPrimaryBgColor: '#ff901a',
  accentContrastColor: '#000000',
  highlightPrimaryBgColor: 'rgba(255, 244, 232, 1)',
  accentSecondaryBgColor: '#FFE9D1',
  standingsLinkColor: '#8c8c8c',
  ageRestrictTextColor: '#000000',

  primaryBackgroundColor: '#f5f5f5',
  filtersContainerPrimaryBackgroundColor: '#FFFFFF',
  pillActiveBackgroundColor: '#ff901a',
  pillBackgroundColor: '#fafafa',
  pillActiveBorderColor: '#ff901a',
  pillBorderColor: '#f0f0f0',
  pillActiveTextColor: '#ffffff',
  pillTextColor: '#262626',

  statsContainerBackgroundColor: '#fafafa',
  socialIconBgColor: '#f5f5f5',
  socialIconColor: '#434343',
  tournamentHeaderBgColor: '#f5f5f5',
  matchRowBgColor: '#fafafa',
  mainEventParticipantNameColor: '#000000',
  secondaryMainEventParticipantNameColor: '#8c8c8c',

  dividerBorderColor: '#999999',
  tabBorderColor: 'rgba(217, 217, 217, 1)',
  progressBarPrimaryBgColor: '#FFFFFF',

  oddsContainerPrimaryBgColor: '#FFFFFF',
  oddItemPrimaryBgColor: '#f5f5f5',
  oddItemLabelColor: '#433939',
  oddItemCoefficientColor: '#0E0E10',
  oddItemHoverColor: '#d9d9d9',
  oddsSelectionBorderColor: '#595959',
  oddsSelectionBackgroundColor: '#f5f5f5',

  fansUnitedContainerPrimaryBgColor: '#FFFFFF',
  fansUnitedContentPrimaryBgColor: '#E6E6E6',
  fansUnitedPillHoverColor: '#F7F7F7',

  countryLogoBorderColor: '#f0f0f0',

  sportEntityContainerPrimaryBgColor: '#FFFFFF',
  standingsTooltipContainerPrimaryBgColor: '#1f1f1f',
  standingsTooltipContainerTextColor: '#ffffff',
  standingsTooltipContainerDateTextColor: '#8c8c8c',

  borderColor: '#999999',
  liveMatchStatusColor: '#8BC34A',
  fullTimeMatchStatusColor: '#999999',

  rowBackgroundColor: '#FFFFFF',
  tabRowBackgroundColor: '#f5f5f5',
  tableRightIndicatorColor: 'rgba(0, 0, 0, 0.5)',
  highLighted: '#FFFCEA',
  surfaceBackgroundColor: '#fafafa',
  tooltipBackgroundColor: '#0E0E10',
  tooltipColor: 'white',

  headerBoxShadowColor: 'rgba(0, 0, 0, 0.05)',
  calendarHeaderBgcColor: '#fafafa',

  // Knockout/Playoff
  knockoutBgColor: '#ffffff',
  knockoutHeaderBgColor: '#fafafa',
  knockoutHeaderBorderColor: '#f0f0f0',
  knockoutGameBgColor: '#fafafa',
  knockoutGameBorderColor: '#f0f0f0',
  knockoutAggEventsBgColor: '#ffffff',
  knockoutAggEventsBorderColor: '#f0f0f0',

  // Additional tokens from original config
  rowBorderColor: '#f5f5f5',
  participantServerImageColor: '#4E4E4E',
  dropdownBorderColor: '#f0f0f0',
  winBackgroundColor: '#B0DB75',
  loseBackgroundColor: '#F27165',
  drawBackgroundColor: '#C9C9C9',
  footballFieldTone: '#d9d9d9',
  footballFieldLineColor: '#595959',
  whiteTeamColorAlternative: '#F8F8F8',
  progressOneBgColor: '#FF8502',
  progressTwoBgColor: '#8c8c8c',
  progressContainerBgColor: '#f0f0f0',
  subHeaderBgColor: '#f0f0f0',
  progressTextColor: '#8c8c8c',
  progressHighlightedColor: '#000000',
  statusBadgeBgColor: '#d9d9d9',
  statusBadgeTextColor: '#000000',

  // Team squad
  playerStatisticsColor: '#8c8c8c',

  // Table team name
  playerTeamColor: '#8c8c8c',

  // Multisport
  borderMultiSportColor: '#d9d9d9',
  multiSportCommonColor: '#8c8c8c',
  teamLostColor: '#8c8c8c',
  gamePartColor: '#4CAF50',
  multiSportWinner: '#D80027',
  multiSportTextColor: '#121212',
  multisportHighlightColor: '#ff901a',
  multiSportBgColor: '#FFFFFF',
  multiSportHoverColor: '#fafafa',
  multiSportDropdownButtonBgColor: '#ff901a',
  dropdownActiveDateBgColor: '#ff901a',
  groupCountColor: '#618934',

  // Dropdown
  dropdownBtnColor: '#FFFFFF',
  dropdownActiveBgColor: '#FFF4E8',
  selectOptionBgColor: '#FFFFFF',
  selectOptionBorderColor: '#f0f0f0',
  selectButtonSecondaryColor: '#9A9A9A',
  dropdownArrowIconColor: '#9A9A9A',
  dropdownCalendarIconColor: '#d9d9d9',

  liveIndicatorColor: '#4CAF50',
  postponedMatchColor: '#D92033',
  stakesBgColor: '#ffffff',
  teamStakesBorderColor: '#d9d9d9',
  stakesSelectionBgColor: '#f5f5f5',
  stakesSelectedBgColor: '#000000',
  selectedStakeColor: '#ffffff',
  stakeInputBorderColor: '#FF901A',
  roundColor: '#8c8c8c',

  // Tournament
  tournamentBgColor: '#f5f5f5',

  // Standings
  relegationColor: '#d01a1a',
  relegationPlayoff: '#ff6666',
  promotion: '#1262fa',
  promotionPlayoff: '#89aff8',
  championshipPlayoff: '#89aff8',
  tierTwo: '#2c782c',
  tierTwoPlayoff: '#52cc52',
  topPlayoff: '#89aff8',
  top: '#1262fa',

  // Lineups
  lineupsHeaderContainerBgColor: '#d9d9d9',
  collapsibleBgColor: '#f0f0f0',
  lineupsRowEvenBgColor: '#ffffff',
  lineupsRowOddBgColor: '#fafafa',
  lineupsSecondaryTextColor: '#8c8c8c',
  mobileTabsSelectedBgColor: '#d9d9d9',
  lineupsPrimaryBackgroundColor: '#ffffff',

  // Match center
  tabTextColor: '#000000',
  tabActiveTextColor: '#000000',
  tabBackgroundColor: '#f0f0f0',
  tabActiveBackgroundColor: '#FF8400',
  tabMenuBorderColor: '#d9d9d9',
  matchCenterPrimaryBackgroundColor: '#ffffff',

  // Timeline
  secondaryHeaderTextColor: '#8c8c8c',
  timelineTabBackgroundColor: '#fafafa',
  timelineBackgroundColor: 'white',
  timelineLineColor: '#d9d9d9',

  // Player
  playerPrimaryBackgroundColor: '#ffffff',
  playerSecondaryTextColor: '#8c8c8c',
  playerBioBackgroundColor: '#f5f5f5',
  playerBioTextColor: '#000000',
  playerProfileBorderColor: '#f0f0f0',

  // Team Form
  upcomingMatch: '#bfbfbf',
  winOutcomeBG: '#8BC34A',
  drawOutcomeBG: '#FFB15F',
  lossOutcomeBG: '#E25160',
  overtimeBG: '#FFFF00',

  // Team
  teamPrimaryBackgroundColor: '#ffffff',
  teamSecondaryTextColor: '#8c8c8c',
  emptyTeamImage: '#fafafa',

  // Standings V2
  tableHeaderBG: '#fafafa',
  tableBorderColor: '#f0f0f0',
  tableRankHighlightColor: '#89B1FD',

  // Sport entity colors
  sportEntityOneColor: '#027BB5',
  sportEntityTwoColor: '#CD0E0E',
  sportEntityLesserStatBgColor: '#fafafa',
};
